/**
 * Get the base URL for the AI backend API.
 * In devtools, default to the same platform backend host selection that other
 * frontend clients use.
 * Keep explicit overrides for standalone/dev scenarios.
 */

let _overrideBaseUrl: string | undefined;

// Overrides only the chat endpoint path (e.g. "/chat/atlas").
// Keeps the platform base URL intact so session/shared API calls still work.
let _overrideChatPath: string | undefined;

function getDefaultPlatformApiBaseUrl(): string {
  const isLocal =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1" ||
      process.env.NODE_ENV === "development");

  return isLocal ? "http://localhost:5110" : "https://staging.services.leadconnectorhq.com";
}

export function setApiBaseUrl(url: string): void {
  _overrideBaseUrl = url;
}

export function clearApiBaseUrl(): void {
  _overrideBaseUrl = undefined;
}

export function getApiBaseUrl(): string {
  if (_overrideBaseUrl !== undefined) return _overrideBaseUrl;
  if (typeof process !== "undefined" && process.env) {
    return (
      process.env.VUE_APP_AI_API_URL ||
      process.env.NEXT_PUBLIC_AI_API_URL ||
      getDefaultPlatformApiBaseUrl()
    );
  }
  return getDefaultPlatformApiBaseUrl();
}

export function apiUrl(path: string): string {
  return `${getApiBaseUrl()}${path}`;
}

/** Override the chat streaming endpoint path. Does not affect the base URL. */
export function setChatPath(path: string): void {
  _overrideChatPath = path;
}

export function clearChatPath(): void {
  _overrideChatPath = undefined;
}

/** Returns the overridden chat path, or undefined to use the default. */
export function getChatPath(): string | undefined {
  return _overrideChatPath;
}
